<!--
 * @Author: 仙道
 * @Date: 2022-10-28 20:39:24
 * @LastEditTime: 2022-11-22 13:42:01
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/vue/DevModelTab/Maintenance.vue
-->
<template>
  <div class="w-full">
    <div class="table-operator" v-if="!disabled">
      <a-button @click="handleTableAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleTableSave" icon="save">保存</a-button>
    </div>
    <j-vxe-table
      :columns="tableColumns"
      :dataSource="dataSource"
      :disabled="disabled"
      :height="300"
      :loading="loading"
      @edit-closed="handleEditClosed"
      keep-source
      ref="vTable"
      row-selection
    >
      <template v-if="!disabled" v-slot:action="props">
        <a-button @click="handleCopy(props)" class="mr-10px" icon="copy" key="copy" size="small"></a-button>
        <a-popconfirm @confirm="handleDL(props)" title="确定删除吗？">
          <a-button icon="delete" key="delete" size="small" type="danger"></a-button>
        </a-popconfirm>
      </template>
    </j-vxe-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { JVXETypes } from '@/components/jeecg/JVxeTable'
  import { getAction, postAction } from '@/api/manage';

  export default {
    name: 'Maintenance',
    components: {

    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      modelId: {
        type: String,
        default: '',
        required: false
      },
    },
    // 定义属性
    data () {
      return {
        tableColumns: [

          {
            title: '保养项目',
            key: 'projectCode',
            sortable: true,
            type: JVXETypes.select,
            width: '150px',
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],

            dictCode: 'maintaince_type',
            placeholder: '请选择${title}',
          },

          {
            title: '部位',
            key: 'maintenancePlace',
            type: JVXETypes.input,
            minWidth: '150px',
            sortable: true,
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],

            placeholder: '请选择${title}',
          },
          {
            title: '保养操作',
            key: 'maintenanceOperate',
            type: JVXETypes.input,
            minWidth: '180px',
            sortable: true,
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],

            placeholder: '请选择${title}',
          },
          {
            title: '保养周期',
            key: 'maintenanceIntervals',
            type: JVXETypes.input,
            sortable: true,
            width: '150px',
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],

            placeholder: '请输入',
          },
          {
            title: '单位',
            key: 'maintenanceUnit',
            type: JVXETypes.select,
            sortable: true,
            width: '150px',
            dictCode: 'maintaince_timeunit',
            placeholder: '请选择',
          },
          {
            title: '计时方式',
            key: 'tickingType',
            dictCode: 'maintaince_timertype',
            type: JVXETypes.select,
            width: '150px',
            sortable: true,
            placeholder: '请选择',
          },],
        dataSource: [],
        loading: false,

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {
      modelId: {
        immediate: true,

        handler (v) {
          if (v) {
            this.loadData()
          }
        }
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

      loadData () {
        getAction('/maintenance/devMaintenanceStlSub/queryStlSubByDevTypeIds', {
          devTypeId: this.modelId
        }).then(res => {
          if (res.success) {
            this.dataSource = res.result.records
          }
        })

      },
      handleEditClosed () { },
      handleTableAdd () {
        this.$refs.vTable.addRows({
          devTypeId: this.modelId,
          tickingType: '1',
          maintenanceUnit: '1'
        })
      },
      handleTableSave () {
        // 校验整个表格
        const $table = this.$refs.vTable
        let newData = $table.getNewDataWithId()
        if (!newData.length) {
          this.$message.error('无新增数据！')
          return
        }
        // const xTable = this.$refs.vTable.$refs.vxe.$refs.xTable
        const resultRows = newData.map(item => this.$Jlodash.omit(item, ['id']))
        $table.validate(newData).then((errMap) => {

          //   // 校验通过
          if (!errMap) {
            // 获取新增的数据

            console.log('-- 新增的数据：', newData)
            this.loading = true
            postAction('/maintenance/devMaintenanceStlSub/batchAdd', resultRows).then(res => {
              if (res.success) {
                this.$message.success(`保存成功！`)
              } else {
                this.$message.warn(`保存失败：` + res.message)
              }
            }).finally(() => {
              this.loading = false
            })
          }
        })
      }, handleDL (v) {
        console.info('==========del', v);

        const { row, rowId } = v
        if (rowId == row.id) {
          this.$refs.vTable.removeRows(row)
          // this.$message.success('删除成功')
          return
        }
        if (rowId !== row.id) {
          deleteAction('/maintenance/devMaintenanceStlSub/delete', { id: row.id }).then(res => {
            if (rs.success) {
              this.$refs.vTable.removeRows(row)
              this.$message.success('删除成功')
            }
          })
        }

      },

    }
  }
</script>

<style lang='scss' scoped>


</style>